import { Exclude } from "class-transformer";

import type { MangopayWalletBalance } from "./MangopayWalletBalance";

@Exclude()
export class MangopayWallet {
    public Id: string;

    public CreationDate: number;

    public Tag: string;

    public Owners: Array<string>;

    public Balance: MangopayWalletBalance;

    public FundsType: "DEFAULT" | "FEES" | "CREDIT";

    public Description: string;

    public Currency: string;

    public usableAmount?: number;
}
